module.exports = __webpack_public_path__ + "d3e1e36a9f0cbfa0de5c0bf2dda800e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/red-hot-air-balloon.png
// module id = 578
// module chunks = 0